import {MapDrawingController} from '../openstreetmap.controller';

export interface OsmMapDrawingHost {
  isMapInitialized: boolean;
  drawingController: MapDrawingController | undefined;
}

export function enableOsmPolygonDrawing(host: OsmMapDrawingHost): void {
  if (!host.isMapInitialized || !host.drawingController) {
    return;
  }
  host.drawingController.enablePolygonDrawing();
}

export function enableOsmRectangleDrawing(host: OsmMapDrawingHost): void {
  if (!host.isMapInitialized || !host.drawingController) {
    return;
  }
  host.drawingController.enableRectangleDrawingMode();
}

export function isOsmDrawingRectangleActive(host: OsmMapDrawingHost): boolean {
  if (!host.isMapInitialized || !host.drawingController) {
    return false;
  }
  return host.drawingController.isDrawingRectangleActive();
}

export function isOsmDrawingPolygonActive(host: OsmMapDrawingHost): boolean {
  if (!host.isMapInitialized || !host.drawingController) {
    return false;
  }
  return host.drawingController.isDrawingPolygonActive();
}

export function toggleOsmDistanceMeasurement(host: OsmMapDrawingHost): void {
  if (!host.isMapInitialized) {
    return;
  }
  if (!host.drawingController) {
    console.error('Drawing controller not available');
    return;
  }
  host.drawingController.toggleDistanceMeasurement();
}

export function isOsmDistanceMeasurementMode(host: OsmMapDrawingHost): boolean {
  if (!host.isMapInitialized || !host.drawingController) {
    return false;
  }
  return host.drawingController.isDistanceMeasurementModeActive();
}

export function enableOsmBoxPolygonDrawing(host: OsmMapDrawingHost): void {
  if (!host.isMapInitialized) {
    return;
  }
  if (!host.drawingController) {
    console.error('Drawing controller not available');
    return;
  }
  host.drawingController.enableBoxPolygonDrawing();
}

export function enableOsmCustomPolygonDrawing(host: OsmMapDrawingHost): void {
  if (!host.isMapInitialized) {
    return;
  }
  if (!host.drawingController) {
    console.error('Drawing controller not available');
    return;
  }
  host.drawingController.enableCustomPolygonDrawing();
}

export function isOsmDrawingBoxPolygonActive(host: OsmMapDrawingHost): boolean {
  if (!host.isMapInitialized || !host.drawingController) {
    return false;
  }
  return host.drawingController.isDrawingBoxPolygonActive();
}

export function isOsmDrawingCustomPolygonActive(host: OsmMapDrawingHost): boolean {
  if (!host.isMapInitialized || !host.drawingController) {
    return false;
  }
  return host.drawingController.isDrawingCustomPolygonActive();
}

export function clearAllOsmDrawnShapes(host: OsmMapDrawingHost): void {
  if (!host.isMapInitialized) {
    return;
  }
  if (!host.drawingController) {
    console.error('Drawing controller not available');
    return;
  }
  host.drawingController.clearAllDrawnShapes();
  host.drawingController.disableAllDrawingModes();
}
